import React from "react";
import Star from "./Star";

interface RatingProps {
  value: number; // 0..5 (fractional values are floored)
  size?: number;
  className?: string;
}

const clamp = (n: number, min: number, max: number) =>
  Math.max(min, Math.min(max, n));

const Rating: React.FC<RatingProps> = ({
  value,
  size = 18,
  className = "",
}) => {
  const filledCount = Math.floor(clamp(value ?? 0, 0, 5));
  return (
    <div
      className={`inline-flex items-center gap-1 ${className}`}
      aria-label={`Rating: ${filledCount} out of 5`}
    >
      {Array.from({ length: 5 }, (_, i) => (
        <Star key={i} filled={i < filledCount} size={size} />
      ))}
    </div>
  );
};

export default Rating;
